/* QORI · interacciones de las secciones qo-* (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.qo-reveal:not(.qo-visible), .qo-zoom:not(.qo-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('qo-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('qo-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Parallax suave del hero */
  function initParallax() {
    var imgs = document.querySelectorAll('[data-qo-parallax]');
    if (!imgs.length || reduce) return;
    var tick = false;
    function run() {
      imgs.forEach(function (img) {
        var box = img.parentElement.getBoundingClientRect();
        var f = parseFloat(img.getAttribute('data-qo-parallax')) || 0.15;
        if (box.bottom < 0 || box.top > window.innerHeight) return;
        img.style.transform = 'translate3d(0,' + (-box.top * f) + 'px,0)';
      });
      tick = false;
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* Manifiesto: las palabras se encienden según avanzas */
  function initManifiesto() {
    document.querySelectorAll('[data-qo-manifiesto]').forEach(function (root) {
      if (root.dataset.qoListo) return; root.dataset.qoListo = '1';
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (n) {
        if (!n.nodeValue.trim()) return;
        var frag = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (w) {
          if (!w) return;
          if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
          var s = document.createElement('span'); s.className = 'qo-palabra'; s.textContent = w; frag.appendChild(s);
        });
        n.parentNode.replaceChild(frag, n);
      });
      root.querySelectorAll('.qo-pastilla').forEach(function (p) { p.classList.add('qo-palabra'); });
      var words = root.querySelectorAll('.qo-palabra');
      if (reduce) { words.forEach(function (w) { w.classList.add('qo-on'); }); return; }
      var tick = false;
      function run() {
        var r = root.getBoundingClientRect(), vh = window.innerHeight;
        var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
        p = Math.max(0, Math.min(1, p));
        var n = Math.round(p * words.length);
        words.forEach(function (w, i) { w.classList.toggle('qo-on', i < n); });
        tick = false;
      }
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
      run();
    });
  }

  /* Cifras que cuentan al entrar en pantalla */
  function initContadores() {
    var els = document.querySelectorAll('[data-qo-contar]');
    if (!els.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-qo-contar'));
      var dec = (el.getAttribute('data-qo-contar').split(/[.,]/)[1] || '').length;
      if (isNaN(fin) || reduce) return;
      var t0 = null, dur = 1400;
      function paso(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        el.firstChild.nodeValue = (fin * e).toFixed(dec).replace('.', ',');
        if (k < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { animar(x.target); io.unobserve(x.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Escena sticky: cambia la foto según la característica visible */
  function initEscena() {
    document.querySelectorAll('[data-qo-escena]').forEach(function (root) {
      var imgs = root.querySelectorAll('.qo-escena__img');
      var rasgos = root.querySelectorAll('[data-qo-rasgo]');
      var cont = root.querySelector('[data-qo-escena-contador]');
      if (!imgs.length || !rasgos.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (!x.isIntersecting) return;
          var i = parseInt(x.target.getAttribute('data-qo-rasgo'), 10);
          imgs.forEach(function (im, j) { im.classList.toggle('qo-activa', j === i); });
          if (cont) cont.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + rasgos.length).slice(-2);
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      rasgos.forEach(function (r) { io.observe(r); });
    });
  }

  /* Un día: el sol recorre la línea de tiempo */
  function initDia() {
    document.querySelectorAll('[data-qo-dia]').forEach(function (root) {
      var linea = root.querySelector('.qo-dia__linea');
      if (!linea || reduce) return;
      var tick = false;
      function run() {
        var r = root.getBoundingClientRect(), vh = window.innerHeight;
        var p = Math.max(0, Math.min(1, (vh * 0.8 - r.top) / (r.height)));
        linea.style.setProperty('--qo-linea-ancho', linea.offsetWidth + 'px');
        linea.style.setProperty('--qo-progreso', p.toFixed(3));
        tick = false;
      }
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
      window.addEventListener('resize', run);
      run();
    });
  }

  /* Galería de producto */
  function initGaleria() {
    document.querySelectorAll('[data-qo-galeria]').forEach(function (root) {
      var principal = root.querySelector('[data-qo-principal]');
      var minis = Array.prototype.slice.call(root.querySelectorAll('[data-qo-mini]'));
      if (!principal || !minis.length) return;
      var actual = 0;
      function ir(i) {
        actual = (i + minis.length) % minis.length;
        var m = minis[actual];
        principal.style.opacity = 0;
        setTimeout(function () {
          principal.src = m.getAttribute('data-qo-grande');
          principal.srcset = '';
          principal.alt = m.querySelector('img').alt;
          principal.style.opacity = 1;
        }, 180);
        minis.forEach(function (x, j) { x.classList.toggle('qo-activa', j === actual); });
      }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { ir(i); }); });
      var prev = root.querySelector('[data-qo-prev]'), next = root.querySelector('[data-qo-next]');
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); });
      var x0 = null;
      principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      principal.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1)); x0 = null;
      });
    });
  }

  /* Variantes, cantidad y barra fija */
  function initCompra() {
    document.querySelectorAll('[data-qo-compra]').forEach(function (root) {
      var json = root.querySelector('[data-qo-variantes-json]');
      var input = root.querySelector('[data-qo-variante-id]');
      var btns = document.querySelectorAll('[data-qo-anadir-texto]');
      var precios = document.querySelectorAll('[data-qo-precio]');
      var comparados = root.querySelectorAll('[data-qo-comparado]');
      var variantes = json ? JSON.parse(json.textContent) : [];
      var txtAnadir = root.getAttribute('data-qo-texto-anadir');
      var txtAgotado = root.getAttribute('data-qo-texto-agotado');

      root.querySelectorAll('[data-qo-opcion]').forEach(function (grupo) {
        grupo.querySelectorAll('[data-qo-valor]').forEach(function (b) {
          b.addEventListener('click', function () {
            grupo.querySelectorAll('[data-qo-valor]').forEach(function (x) { x.classList.remove('qo-sel'); });
            b.classList.add('qo-sel');
            var sel = Array.prototype.map.call(root.querySelectorAll('[data-qo-opcion]'), function (g) {
              var s = g.querySelector('.qo-sel'); return s ? s.getAttribute('data-qo-valor') : null;
            });
            var v = variantes.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
            if (!v) return;
            input.value = v.id;
            precios.forEach(function (p) { p.textContent = v.precio; });
            comparados.forEach(function (c) { c.textContent = v.comparado || ''; c.style.display = v.comparado ? '' : 'none'; });
            btns.forEach(function (bt) {
              bt.disabled = !v.available;
              var t = bt.querySelector('[data-qo-btn-label]');
              if (t) t.textContent = v.available ? txtAnadir : txtAgotado;
              var pr = bt.querySelector('.qo-btn__precio'); if (pr) pr.style.display = v.available ? '' : 'none';
            });
            if (history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
          });
        });
      });

      var cant = root.querySelector('[data-qo-cantidad]');
      if (cant) {
        var inp = cant.querySelector('input');
        cant.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(inp.value, 10) || 1;
            inp.value = Math.max(1, n + parseInt(b.getAttribute('data-qo-paso'), 10));
          });
        });
      }

      var sticky = document.querySelector('[data-qo-sticky]');
      var ancla = root.querySelector('[data-qo-form-ancla]');
      if (sticky && ancla && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (x) { sticky.classList.toggle('qo-mostrar', !x.isIntersecting && x.boundingClientRect.top < 0); });
        }).observe(ancla);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          var f = root.querySelector('form[action*="/cart/add"]');
          if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
        });
      }
    });
  }


  /* Texto SEO plegable */
  function initSeo() {
    document.querySelectorAll('[data-qo-seo-btn]').forEach(function (b) {
      if (b.dataset.qoListo) return; b.dataset.qoListo = '1';
      var caja = b.parentElement.querySelector('[data-qo-seo]');
      b.addEventListener('click', function () {
        var abierto = caja.classList.toggle('qo-plegado') === false;
        b.textContent = abierto ? b.getAttribute('data-menos') : b.getAttribute('data-mas');
        b.setAttribute('aria-expanded', abierto);
      });
    });
  }

  function init() { initSeo(); initReveal(); initParallax(); initManifiesto(); initContadores(); initEscena(); initDia(); initGaleria(); initCompra(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
